import { forwardRef } from 'react'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuGroup,
  MenuOptionGroup,
  MenuItemOption,
  MenuButtonProps,
  Text,
} from '@chakra-ui/react'
import styled from '@emotion/styled'

export type MultiSelectProps = {
  label: string
  placeholder?: string
  options: string[]
  onChange?: (selectedValues: string[]) => void
  buttonProps?: MenuButtonProps
  selectedOptions: string[]
  setSelectedOptions: (arr: string[]) => void
  isDisabled?: boolean
}

export const MultiSelect = forwardRef<HTMLInputElement, MultiSelectProps>(
  (
    {
      label,
      placeholder,
      options,
      onChange,
      buttonProps,
      selectedOptions,
      setSelectedOptions,
      isDisabled,
    }: MultiSelectProps,
    ref,
  ): JSX.Element => {
    return (
      <Container ref={ref}>
        <StyledText>{label}</StyledText>
        <Menu closeOnSelect={false}>
          {({ onClose }) => (
            <>
              <MenuButton
                /* eslint-disable @typescript-eslint/ban-ts-comment */
                // @ts-ignore <MenuButton> does have a 'type' prop because it is just a button. This is to make sure clicking this doesn't submit any forms.
                type='button'
                /* eslint-enable @typescript-eslint/ban-ts-comment */
                borderWidth={1}
                borderRadius={'6px'}
                p={2}
                px={4}
                w='100%'
                maxH='40px'
                minH='40px'
                disabled={isDisabled}
                {...buttonProps}
              >
                {`${
                  selectedOptions.length > 0 ? `Moods (${selectedOptions.length})` : placeholder
                }`}
              </MenuButton>
              <MenuList className='menu-list'>
                <MenuGroup title={undefined}>
                  <MenuItem
                    onClick={() => {
                      setSelectedOptions([])
                      onClose()
                    }}
                  >
                    Clear all
                  </MenuItem>
                </MenuGroup>
                <MenuDivider />
                <MenuOptionGroup
                  title={undefined}
                  value={selectedOptions}
                  type='checkbox'
                  /* eslint-disable @typescript-eslint/ban-ts-comment */
                  // @ts-ignore Arguments type is just wrong upstream.
                  onChange={(values: string[]) => {
                    setSelectedOptions(values.filter((_) => _.length))
                    onChange?.(values)
                  }}
                  /* eslint-enable @typescript-eslint/ban-ts-comment */
                >
                  {options.map((option) => {
                    return (
                      <MenuItemOption
                        key={`multiselect-menu-${option}`}
                        /* eslint-disable @typescript-eslint/ban-ts-comment */
                        // @ts-ignore <MenuItemOption> does have a 'type' prop because it is just a button. This is to make sure clicking this doesn't submit any forms.
                        type='button'
                        /* eslint-enable @typescript-eslint/ban-ts-comment */
                        value={option}
                      >
                        {option}
                      </MenuItemOption>
                    )
                  })}
                </MenuOptionGroup>
              </MenuList>
            </>
          )}
        </Menu>
      </Container>
    )
  },
)

MultiSelect.displayName = 'MultiSelect'

const Container = styled.div`
  .menu-list {
    height: 20rem;
    overflow: hidden;
    overflow-y: scroll;
  }
`

const StyledText = styled(Text)`
  margin-bottom: 0.5rem;
`
